// extracted by mini-css-extract-plugin
export default {"executiveCouncil":"executive-council_executiveCouncil__t7Mk6","total":"executive-council_total__b-VL9"};